var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8736 5.61138L5.04842 11.1369C4.69778 11.6428 3.90424 11.3953 3.90424 10.7793V7.13738H0.706509C0.199964 7.13738 -0.0984907 6.56847 0.190418 6.15166L4.0156 0.62611C4.36624 0.120201 5.15978 0.367747 5.15978 0.983747V4.62566H8.35751C8.86342 4.62566 9.16187 5.19456 8.8736 5.61138Z",
    fill: "#021317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power_icon.45e8bcbc428617a39aac6581b80aefe8.svg";
export { ForwardRef as ReactComponent };